import { IDrawBudgetItem, IDrawReceipt } from '@apply/api/src/api/DrawApi';
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import { FileSelectDialog } from '../../../../../../../apps/admin/src/common/SharedComponents';
import { NumericFormat } from 'react-number-format';
import { applicationInsights } from '../../../../../../../apps/admin/src/ApplicationInsights';
import { DrawApi } from '@apply/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import { DrawBudgetCategory } from '../functions';
interface IReceiptsModalProps {
    isOpen: boolean;
    categories: DrawBudgetCategory[];
    receipt?: IDrawReceipt;
    onSave: (receipt: IDrawReceipt) => void;
    onClose: () => void;
}
export interface IFileSelectDialogProps {
    ownerId?: string;
    isOpen: boolean;
    isReplace: boolean;
    fileTypeName?: string;
    maxFiles: number;
}
const ReceiptsModal: React.FC<IReceiptsModalProps> = ({ isOpen, categories, receipt, onSave, onClose }) => {
    const style = {
        label: {
            color: '#959595',
        },
    };
    const [selectedCategory, set_selectedCategory] = useState<DrawBudgetCategory>(categories[0]);
    const [fileSelectOptions, set_fileSelectOptions] = useState<IFileSelectDialogProps>({
        ownerId: undefined,
        isOpen: false,
        maxFiles: 1,
        isReplace: true,
        fileTypeName: `${categories[0]} Receipt`,
    });
    const [paymentAmount, set_paymentAmount] = useState<number>();
    const [note, set_note] = useState<string>();
    const [file, set_file] = useState<File | undefined>();

    const openFileDialog = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        e.stopPropagation();

        const options = {
            ownerId: undefined,
            isOpen: true,
            maxFiles: 1,
            isReplace: true,
            fileTypeName: `${selectedCategory?.description} Receipt`,
        };
        set_fileSelectOptions(options);
    };

    const handleFileSubmit = (_: any, currentFiles: any) => {
        set_file(currentFiles[0]);

        set_fileSelectOptions({ ...fileSelectOptions, isOpen: false });
    };

    const handleReset = () => {
        onClose();
        set_paymentAmount(0);
        set_note('');
        set_selectedCategory(categories[0]);
        set_file(undefined);
    };

    const handleSave = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        e.stopPropagation();

        onSave &&
            onSave({
                amount: paymentAmount,
                note: note,
                drawReceiptId: receipt?.drawReceiptId ?? 0,
                drawBudgetItemId: selectedCategory.id,
                file: file,
                downloadToken: undefined,
            });

        handleReset();
    };

    useEffect(() => {
        if (isOpen && receipt) {
            set_note(receipt.note);
            set_paymentAmount(receipt.amount);

            const category = categories.find((x) => x.id === receipt?.drawBudgetItemId);
            if (category) set_selectedCategory(category);
        }
    }, [isOpen]);
    return (
        <>
            {isOpen && (
                <>
                    <div>
                        <Dialog
                            open={isOpen}
                            className='receiptsModal'
                            onClose={handleReset}
                        >
                            <div
                                className='page-header'
                                role='banner'
                            >
                                <h1 style={{ flex: '0 0 100%', maxWidth: '90%' }}>Add/Edit Receipts</h1>
                            </div>
                            <DialogContent style={{ width: '400px' }}>
                                <select
                                    style={{ marginBottom: '1rem' }}
                                    onChange={(e) => {
                                        const category = categories.find((x) => x.id === Number(e.target.value));
                                        if (category) set_selectedCategory(category);
                                    }}
                                    value={selectedCategory?.id}
                                >
                                    {categories.map((category) => (
                                        <option
                                            key={category.id}
                                            value={category.id}
                                        >
                                            {category.description}
                                        </option>
                                    ))}
                                </select>
                                <div className='small-12 medium-6 medium-12 large-12'>
                                    <label
                                        style={style.label}
                                        htmlFor='paymentAmount'
                                    >
                                        Payment Amount
                                    </label>
                                    <NumericFormat
                                        thousandSeparator=','
                                        prefix='$'
                                        id='paymentAmount'
                                        fixedDecimalScale
                                        decimalScale={2}
                                        allowNegative={false}
                                        value={paymentAmount}
                                        onValueChange={(values) => {
                                            set_paymentAmount(values.floatValue || 0);
                                        }}
                                        required={false}
                                    />
                                </div>
                                <div
                                    className='small-12 medium-6 medium-12 large-12'
                                    style={{ marginTop: 20 }}
                                >
                                    <label
                                        style={style.label}
                                        htmlFor='notesId'
                                    >
                                        Notes For Receipt (Optional)
                                    </label>
                                    <input
                                        id='notesId'
                                        type='text'
                                        name='notes'
                                        placeholder='Notes'
                                        onChange={(e) => set_note(e.target.value)}
                                        value={note}
                                    />
                                </div>
                                <div
                                    className='small-12 medium-6 large-12'
                                    style={{ marginTop: 20 }}
                                >
                                    {!(file || receipt?.fileName) ? (
                                        <button
                                            type='button'
                                            className='button hollow admin-slim-button'
                                            data-dismiss='modal'
                                            onClick={(e) => openFileDialog(e)}
                                            style={{
                                                height: '25px',
                                                marginTop: '12px',
                                            }}
                                        >
                                            <span>Upload File</span>
                                        </button>
                                    ) : (
                                        <div style={{ marginTop: 10, fontWeight: 600 }}>
                                            <FontAwesomeIcon
                                                icon={faFileInvoiceDollar}
                                                size={'1x'}
                                                className='color-green'
                                                style={{ marginLeft: 5, marginRight: 5 }}
                                            />
                                            {file?.name ?? receipt?.fileName}
                                        </div>
                                    )}
                                </div>
                            </DialogContent>
                            <DialogActions>
                                <button
                                    className='primary button admin-slim-button'
                                    onClick={handleSave}
                                    disabled={!paymentAmount || (!file && !receipt?.fileName) || !selectedCategory}
                                >
                                    Save
                                </button>
                                <button
                                    className='hollow button admin-slim-button'
                                    onClick={handleReset}
                                >
                                    Close
                                </button>
                            </DialogActions>
                        </Dialog>
                    </div>
                    <FileSelectDialog
                        options={fileSelectOptions}
                        onSubmit={handleFileSubmit}
                        onCancel={() =>
                            // @ts-ignore
                            set_fileSelectOptions((o) => ({
                                ...o,
                                isOpen: false,
                            }))
                        }
                    />
                </>
            )}
        </>
    );
};

export default ReceiptsModal;
